export type PhotoCategory = '창업' | '취업' | '교육';

export type Photo = {
  id: string;
  src: string;
  title: string;
  category: PhotoCategory;
  year: string;
  description: string;
  tags: string[];
  client?: string;
  orientation: 'portrait' | 'landscape';
  /** 접수 마감일 (YYYY-MM-DD) 또는 '상시' */
  deadline: string;
};

export const categories: Array<'전체' | PhotoCategory> = [
  '전체',
  '창업',
  '취업',
  '교육',
];

const raw: Photo[] = [
  // ---------- 창업 — 8 ----------
  {
    id: 'dabom-001',
    deadline: '2026-09-27',
    src: 'https://readdy.ai/api/search-image?query=Two%20young%20Korean%20co-founders%20reviewing%20a%20business%20plan%20together%20in%20a%20bright%20minimal%20coworking%20studio%2C%20whiteboard%20behind%20them%2C%20warm%20natural%20window%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain%2C%20calm%20hopeful%20mood&width=900&height=1200&seq=dabom-01&orientation=portrait',
    title: '청년창업 도약패키지', category: '창업', year: '2026',
    description: '사업화 자금과 멘토링, 판로 개척까지 한 번에 지원하는 청년 창업 통합 패키지.',
    tags: ['지원사업', '사업화 자금', '멘토링'], client: '중소벤처기업부', orientation: 'portrait',
  },
  {
    id: 'dabom-002',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20small%20business%20owner%20arranging%20handmade%20goods%20on%20the%20counter%20of%20a%20cozy%20minimal%20shop%2C%20warm%20afternoon%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain%2C%20quiet%20dignified%20mood&width=900&height=1200&seq=dabom-02&orientation=portrait',
    title: '소상공인 온라인 진출 지원', category: '창업', year: '2026',
    description: '온라인 스토어 구축과 마케팅, 배송까지 함께 돕는 소상공인 판로 지원 사업.',
    tags: ['지원사업', '온라인 판로', '소상공인'], client: '소상공인시장진흥공단', orientation: 'portrait',
  },
  {
    id: 'dabom-003',
    deadline: '2026-10-06',
    src: 'https://readdy.ai/api/search-image?query=A%20startup%20team%20of%20three%20sketching%20ideas%20on%20a%20glass%20whiteboard%20in%20a%20light%20filled%20minimal%20office%2C%20warm%20neutral%20tones%2C%20editorial%20documentary%20photography%2C%20soft%20natural%20light%2C%20film%20grain&width=900&height=1200&seq=dabom-03&orientation=portrait',
    title: '예비창업자 아이디어 사업화', category: '창업', year: '2025',
    description: '아이디어만 가진 예비창업자에게 초기 자금과 작업 공간, 검증 프로그램을 지원합니다.',
    tags: ['지원사업', '예비창업', '초기자금'], client: '창업진흥원', orientation: 'portrait',
  },
  {
    id: 'dabom-004',
    deadline: '2026-10-20',
    src: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20signing%20a%20grant%20approval%20document%20on%20a%20wooden%20desk%20beside%20a%20laptop%20and%20a%20cup%20of%20coffee%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-04&orientation=portrait',
    title: '창업기업 정책자금 융자', category: '창업', year: '2025',
    description: '창업 초기 기업을 위한 저금리 정책자금 융자 연계 프로그램.',
    tags: ['지원사업', '정책자금', '융자'], client: '중소벤처기업부', orientation: 'portrait',
  },
  {
    id: 'dabom-005',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20entrepreneur%20presenting%20a%20prototype%20to%20two%20mentors%20at%20a%20bright%20minimal%20table%2C%20warm%20natural%20window%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-05&orientation=portrait',
    title: '후기 · 청년창업 도약패키지 신청', category: '창업', year: '2025',
    description: '"서류 준비부터 멘토링까지 도움받아 여섯 달 만에 매출이 두 배가 됐어요."',
    tags: ['신청 후기', '도약패키지', '사업자'], client: '신청자 후기', orientation: 'portrait',
  },
  {
    id: 'dabom-006',
    deadline: '2026-09-29',
    src: 'https://readdy.ai/api/search-image?query=Hands%20assembling%20a%20small%20product%20prototype%20on%20a%20wooden%20workshop%20table%20with%20tools%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain%2C%20focused%20mood&width=900&height=1200&seq=dabom-06&orientation=portrait',
    title: '시제품 제작 지원', category: '창업', year: '2024',
    description: '아이디어를 실제 시제품으로 만들어 주는 설계·제작 지원 사업.',
    tags: ['지원사업', '시제품', '제조'], client: '창업진흥원', orientation: 'portrait',
  },
  {
    id: 'dabom-007',
    deadline: '2026-10-13',
    src: 'https://readdy.ai/api/search-image?query=A%20small%20bakery%20owner%20placing%20fresh%20loaves%20on%20a%20wooden%20shelf%20in%20a%20cozy%20minimal%20bakery%2C%20warm%20morning%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-07&orientation=portrait',
    title: '전통시장 청년상인 육성', category: '창업', year: '2025',
    description: '전통시장에서 새로 시작하는 청년 상인에게 점포와 창업 자금을 지원합니다.',
    tags: ['지원사업', '전통시장', '청년상인'], client: '소상공인시장진흥공단', orientation: 'portrait',
  },
  {
    id: 'dabom-008',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20small%20startup%20team%20having%20a%20relaxed%20meeting%20on%20a%20rooftop%20terrace%20at%20golden%20hour%2C%20city%20skyline%20softly%20blurred%20behind%2C%20editorial%20documentary%20photography%2C%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-08&orientation=portrait',
    title: '후기 · 소상공인 온라인 진출', category: '창업', year: '2024',
    description: '"온라인 판로를 열고 첫 달에 주문 100건을 넘겼습니다. 재고 걱정이 사라졌어요."',
    tags: ['신청 후기', '온라인', '소상공인'], client: '신청자 후기', orientation: 'portrait',
  },

  // ---------- 취업 — 8 ----------
  {
    id: 'dabom-009',
    deadline: '2026-09-28',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20job%20seeker%20in%20a%20neat%20outfit%20sitting%20across%20a%20desk%20in%20a%20bright%20minimal%20interview%20room%2C%20warm%20natural%20window%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-09&orientation=portrait',
    title: '청년 일자리 매칭 지원', category: '취업', year: '2026',
    description: '구직자와 기업을 연결하고 면접 기회까지 이어 주는 청년 일자리 매칭 사업.',
    tags: ['지원사업', '일자리', '매칭'], client: '고용노동부', orientation: 'portrait',
  },
  {
    id: 'dabom-010',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20career%20counselor%20and%20a%20young%20visitor%20talking%20across%20a%20small%20table%20in%20a%20bright%20minimal%20consultation%20room%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-10&orientation=portrait',
    title: '취업 상담 · 컨설팅', category: '취업', year: '2026',
    description: '1:1 취업 상담과 직무 적합도 진단, 이력서 첨삭을 제공하는 상담 프로그램.',
    tags: ['지원사업', '취업 상담', '컨설팅'], client: '한국고용정보원', orientation: 'portrait',
  },
  {
    id: 'dabom-011',
    deadline: '2026-10-05',
    src: 'https://readdy.ai/api/search-image?query=A%20person%20writing%20a%20resume%20on%20a%20laptop%20at%20a%20tidy%20wooden%20desk%20with%20a%20notebook%20and%20coffee%2C%20warm%20morning%20window%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-11&orientation=portrait',
    title: '이력서 · 자기소개서 클리닉', category: '취업', year: '2025',
    description: '서류 통과율을 높이는 이력서·자기소개서 집중 첨삭 클리닉.',
    tags: ['지원사업', '이력서', '자기소개서'], client: '한국고용정보원', orientation: 'portrait',
  },
  {
    id: 'dabom-012',
    deadline: '2026-10-15',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20worker%20in%20a%20clean%20uniform%20starting%20a%20new%20job%2C%20standing%20in%20a%20bright%20minimal%20workplace%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-12&orientation=portrait',
    title: '신중년 재취업 지원', category: '취업', year: '2025',
    description: '40~60대 신중년의 재취업을 돕는 맞춤형 직업 훈련과 취업 연계.',
    tags: ['지원사업', '신중년', '재취업'], client: '고용노동부', orientation: 'portrait',
  },
  {
    id: 'dabom-013',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20small%20group%20of%20job%20seekers%20in%20a%20career%20workshop%20around%20a%20bright%20table%2C%20listening%20attentively%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-13&orientation=portrait',
    title: '후기 · 취업 상담 컨설팅', category: '취업', year: '2025',
    description: '"상담 세 번 만에 서류를 통과하고 최종 합격까지 이어졌어요."',
    tags: ['신청 후기', '취업', '합격'], client: '신청자 후기', orientation: 'portrait',
  },
  {
    id: 'dabom-014',
    deadline: '2026-10-02',
    src: 'https://readdy.ai/api/search-image?query=Two%20people%20shaking%20hands%20warmly%20after%20a%20successful%20interview%20in%20a%20bright%20minimal%20office%2C%20warm%20natural%20window%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-14&orientation=portrait',
    title: '면접 역량 강화 프로그램', category: '취업', year: '2024',
    description: '실전 모의면접과 피드백으로 면접 자신감을 키우는 대비 과정.',
    tags: ['지원사업', '면접', '모의면접'], client: '한국산업인력공단', orientation: 'portrait',
  },
  {
    id: 'dabom-015',
    deadline: '2026-10-11',
    src: 'https://readdy.ai/api/search-image?query=A%20mentor%20reviewing%20a%20design%20portfolio%20with%20a%20young%20mentee%20on%20a%20laptop%20at%20a%20bright%20wooden%20table%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-15&orientation=portrait',
    title: '청년 포트폴리오 멘토링', category: '취업', year: '2025',
    description: '현직자 멘토와 함께 실무 포트폴리오를 완성하는 1:1 멘토링.',
    tags: ['지원사업', '멘토링', '포트폴리오'], client: '한국고용정보원', orientation: 'portrait',
  },
  {
    id: 'dabom-016',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20professional%20walking%20into%20a%20modern%20office%20building%20lobby%20in%20soft%20morning%20light%2C%20warm%20neutral%20tones%2C%20editorial%20documentary%20photography%2C%20muted%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-16&orientation=portrait',
    title: '후기 · 신중년 재취업 지원', category: '취업', year: '2024',
    description: '"50대에 다시 시작했고, 지금은 정규직으로 안정적으로 일하고 있습니다."',
    tags: ['신청 후기', '재취업', '신중년'], client: '신청자 후기', orientation: 'portrait',
  },

  // ---------- 교육 — 8 ----------
  {
    id: 'dabom-017',
    deadline: '2026-09-25',
    src: 'https://readdy.ai/api/search-image?query=A%20bright%20training%20classroom%20with%20a%20small%20group%20of%20adult%20learners%20at%20laptops%2C%20warm%20natural%20window%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-17&orientation=portrait',
    title: '청년 직무훈련 아카데미', category: '교육', year: '2026',
    description: '실무 중심 직무 훈련을 무료로 제공하고 수료 후 취업까지 연계합니다.',
    tags: ['지원사업', '직무훈련', '무료교육'], client: '교육부', orientation: 'portrait',
  },
  {
    id: 'dabom-018',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20person%20studying%20alone%20with%20books%20and%20notes%20at%20a%20wooden%20desk%20by%20a%20large%20window%2C%20warm%20afternoon%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-18&orientation=portrait',
    title: '자기주도 학습 지원', category: '교육', year: '2025',
    description: '학습비와 교재, 온라인 강의를 지원하는 자기주도 학습 프로그램.',
    tags: ['지원사업', '학습비', '교재'], client: '평생교육진흥원', orientation: 'portrait',
  },
  {
    id: 'dabom-019',
    deadline: '2026-09-30',
    src: 'https://readdy.ai/api/search-image?query=A%20learner%20working%20through%20a%20coding%20bootcamp%20exercise%20at%20a%20bright%20desk%20with%20code%20on%20the%20screen%2C%20warm%20neutral%20light%2C%20editorial%20documentary%20photography%2C%20muted%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-19&orientation=portrait',
    title: 'K-디지털 기초역량 훈련', category: '교육', year: '2026',
    description: '코딩·데이터·AI 등 디지털 기초 역량을 키우는 실습 중심 훈련 과정.',
    tags: ['지원사업', '디지털', '코딩'], client: '한국산업인력공단', orientation: 'portrait',
  },
  {
    id: 'dabom-020',
    deadline: '2026-10-08',
    src: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20taking%20careful%20notes%20in%20a%20bright%20minimal%20lecture%20hall%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-20&orientation=portrait',
    title: '대학생 학습 멘토링 · 장학', category: '교육', year: '2025',
    description: '대학생에게 학습 코칭과 장학금을 연계하는 통합 멘토링 프로그램.',
    tags: ['지원사업', '장학금', '멘토링'], client: '한국장학재단', orientation: 'portrait',
  },
  {
    id: 'dabom-021',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20collaborative%20workshop%20table%20covered%20with%20colorful%20sticky%20notes%20while%20a%20small%20group%20discusses%2C%20bright%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-21&orientation=portrait',
    title: '후기 · K-디지털 기초역량 훈련', category: '교육', year: '2025',
    description: '"비전공자인데 여섯 달 만에 데이터 분석가로 취업했어요."',
    tags: ['신청 후기', '디지털', '취업'], client: '신청자 후기', orientation: 'portrait',
  },
  {
    id: 'dabom-022',
    deadline: '2026-10-04',
    src: 'https://readdy.ai/api/search-image?query=A%20barista%20training%20session%20with%20a%20person%20practicing%20latte%20art%20at%20a%20bright%20minimal%20counter%2C%20warm%20morning%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-22&orientation=portrait',
    title: '바리스타 자격 취득 훈련', category: '교육', year: '2024',
    description: '국가자격 취득을 돕는 바리스타 실습 훈련과 자격 응시 연계.',
    tags: ['지원사업', '자격증', '바리스타'], client: '한국산업인력공단', orientation: 'portrait',
  },
  {
    id: 'dabom-023',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20person%20learning%20from%20a%20tablet%20beside%20a%20notebook%20and%20coffee%20at%20a%20bright%20minimal%20desk%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-23&orientation=portrait',
    title: '평생학습 온라인 강좌', category: '교육', year: '2025',
    description: '원하는 분야를 온라인으로 배우는 평생학습 강좌와 학습 이력 관리.',
    tags: ['지원사업', '온라인 강좌', '평생학습'], client: '평생교육진흥원', orientation: 'portrait',
  },
  {
    id: 'dabom-024',
    deadline: '상시',
    src: 'https://readdy.ai/api/search-image?query=A%20proud%20learner%20holding%20a%20training%20completion%20certificate%20in%20a%20bright%20minimal%20room%2C%20warm%20natural%20light%2C%20editorial%20documentary%20photography%2C%20muted%20warm%20neutral%20palette%2C%20film%20grain&width=900&height=1200&seq=dabom-24&orientation=portrait',
    title: '후기 · 직무훈련 아카데미 수료', category: '교육', year: '2024',
    description: '"수료증 하나로 첫 직장을 잡았습니다. 지원이 정말 컸어요."',
    tags: ['신청 후기', '수료', '직무훈련'], client: '신청자 후기', orientation: 'portrait',
  },
];

// Interleave categories so the default "전체" feed feels curated, not blocked.
// Deterministic order (no random) so the loop measurement stays stable.
const byCat = (cat: PhotoCategory) => raw.filter((p) => p.category === cat);
const startups = byCat('창업');
const jobs = byCat('취업');
const trainings = byCat('교육');
const mixed: Photo[] = [];
const maxLen = Math.max(startups.length, jobs.length, trainings.length);
for (let i = 0; i < maxLen; i++) {
  if (startups[i]) mixed.push(startups[i]);
  if (jobs[i]) mixed.push(jobs[i]);
  if (trainings[i]) mixed.push(trainings[i]);
}

export const photos: Photo[] = mixed;